/**
 * @param {number} width - Number between 5 and 100, in increments of 5
 * @return {string}
 */
const sparkWidthClassName = width => `sprk-u-Width-${width}`

export default sparkWidthClassName
